import type { RouteObject } from "react-router";
import { Outlet } from "react-router-dom";

import { Layout as MarketingLayout } from "src/layouts/marketing";
import HomePage from "src/pages";
import Error401Page from "src/pages/401";
import Error404Page from "src/pages/404";
import Error500Page from "src/pages/500";
import CheckoutPage from "src/pages/checkout";
import WorkshopPage from "src/pages/events/workshops";
import WaitPage from "src/pages/wait";
import PricingPage from "src/pages/pricing-page";

import AboutUsPage from "src/pages/aboutus";
import BlogDetailPage from "src/pages/blog/detail";
import BasalTestingCalculatorPage from "src/pages/basal-testing-calculator";
import CommunityResearchPage from "src/pages/community-research";
import ContributionsPage from "src/pages/contributions";
import NightscoutTransferPage from "src/pages/dashboard/nightscout-transfer";
import Catalaogue from "src/pages/dashboard/software/marketing";
import DataPrivacyPage from "src/pages/dataprivacy";
import DiabetesCoachingNlPage from "src/pages/diabetes-coaching-nl";
import DonatePage from "src/pages/donate";
import FullPackagesPage from "src/pages/full-packages";
import { IntroductionSession } from "src/pages/introductionsession";
import CookiePolicyPage from "src/pages/legal/cookie-policypage";
import LegalNoticePage from "src/pages/legal/legalnoticepage";
import LyumjevPage from "src/pages/lyumjev";
import MedicalCoachingPage from "src/pages/medical-coaching";
import NewsletterPage from "src/pages/newsletter";
import NightscoutPage from "src/pages/nightscout";
import PaymentFailed from "src/pages/paymentfailed";
import PaymentSuccessful from "src/pages/paymentsuccessful";
import PrivacyPolicyPage from "src/pages/privacypolicy/privacypolicypage";
import LoopDecisionGuidePage from "src/pages/loop-decision-guide";
import PublicationsPage from "src/pages/publications";
import { WorkingMethodPage } from "src/pages/workmethod";
import { ZorgDomeinHowToRefer } from "src/pages/zorgdomeinreferral";
import { ExplanationOpensourceLooping } from "src/resources/explanationopensourcelooping";
import { authRoutes } from "./auth";
import { authDemoRoutes } from "./auth-demo";
import { blogRoutes } from "./blog";
import { componentsRoutes } from "./components";
import { dashboardRoutes } from "./dashboard";

export const routes: RouteObject[] = [
  {
    element: (
      <MarketingLayout>
        <Outlet />
      </MarketingLayout>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "diabetesmanagementapps",
        element: <Catalaogue />,
      },
      {
        path: "pricing",
        element: <PricingPage />,
      },
      {
        path: "legalnotice",
        element: <LegalNoticePage />,
      },
      {
        path: "aboutus",
        element: <AboutUsPage />,
      },
      {
        path: "dataprivacy",
        element: <DataPrivacyPage />,
      },
      {
        path: "donate",
        element: <DonatePage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "cookie-policy",
        element: <CookiePolicyPage />,
      },
      {
        path: "workshops",
        element: <WorkshopPage />,
      },
      {
        path: "verwijzen",
        element: <ZorgDomeinHowToRefer />,
      },
      {
        path: "workmethod",
        element: <WorkingMethodPage />,
      },
      {
        path: "payment-successful",
        element: <PaymentSuccessful />,
      },
      {
        path: "payment-failed",
        element: <PaymentFailed />,
      },
      {
        path: "introductie",
        element: <IntroductionSession />,
      },
      {
        path: "wait",
        element: <WaitPage />,
      },
      {
        path: "what-is-open-source-looping",
        element: <ExplanationOpensourceLooping />,
      },
      {
        path: "full-packages",
        element: <FullPackagesPage />,
      },
      {
        path: "publications",
        element: <PublicationsPage />,
      },
      {
        path: "resources/loop-decision-guide",
        element: <LoopDecisionGuidePage />,
      },
      {
        path: "community-research",
        element: <CommunityResearchPage />,
      },
      {
        path: "contributions",
        element: <ContributionsPage />,
      },
      {
        path: "nightscout-transfer",
        element: <NightscoutTransferPage />,
      },
      // {
      //   path: "delete-nightscout-data",
      //   element: <DeleteNightscoutDataPage />,
      // },
      {
        path: "basal-testing-calculator",
        element: <BasalTestingCalculatorPage />,
      },
      {
        path: "nightscout",
        element: <NightscoutPage />,
      },
      {
        path: "medical-coaching",
        element: <MedicalCoachingPage />,
      },
      {
        path: "nl/diabetes-coaching",
        element: <DiabetesCoachingNlPage />,
      },
      {
        path: "lyumjev",
        element: <LyumjevPage />,
      },
      {
        path: "newsletter",
        element: <NewsletterPage />,
      },
      {
        path: "unannounced-meal-detection",
        element: <BlogDetailPage />,
      },
      ...componentsRoutes,
      ...blogRoutes,
    ],
  },
  ...authRoutes,
  ...authDemoRoutes,
  ...dashboardRoutes,
  {
    path: "checkout",
    element: <CheckoutPage />,
  },
  {
    path: "401",
    element: <Error401Page />,
  },
  {
    path: "404",
    element: <Error404Page />,
  },
  {
    path: "500",
    element: <Error500Page />,
  },
  {
    path: "*",
    element: <Error404Page />,
  },
];
